<!-- //
动态表单-预览
@auth xuyd
@date 2024-06-11
//-->
<template>
  <div style="height: 100%; position: relative;">
    <div id="workbench" class="workbench"
         :style="{
                width: screenProps.width + 'px',
                height: screenProps.height + 'px',
                'background-color': screenProps.backgroundColor
              }">
      <div v-for="(widgetItem, index) in widgetViewList"
           :key="index"
           class="widget-item"
           :style="{
              width: widgetItem.widgetProps.viewProps.width + 'px',
              height: widgetItem.widgetProps.viewProps.height + 'px',
              top: widgetItem.widgetProps.viewProps.top + 'px',
              left: widgetItem.widgetProps.viewProps.left + 'px',
           }">
        <component :is="widgetItem.widgetProps.widgetViewName" :widget-data="widgetItem.widgetProps"/>
      </div>
    </div>
  </div>
</template>

<script>

import DataFormApi from "@/api/datavisual/dataForm.api";

import {widgetPackage} from '../widget/index.js'; // 组件库
import * as WidgetUtil from '../utils/util.js';

const regComponents = WidgetUtil.registerViewWidget(widgetPackage);

export default {
  name: 'ViewFormPreview',
  components: {
    ...regComponents
  },
  data() {
    return {
      pageId: null,
      screenProps: {
        id: null,
        width: null, // 表单设计宽度
        height: null, // 表单设计高度
        backgroundColor: null, // 表单背景色
      },
      widgetViewList: [],
    }
  },

  async created() {
    this.pageId = this.$route.query.pageId;
    await this.getWorkbenchProps()
    this.getList()
  },

  methods: {
    /**
     * 查询表单信息
     */
    async getWorkbenchProps() {
      await DataFormApi.getFormInfo(this.pageId).then(resp => {
        this.screenProps = resp.data;
      })
    },
    /**
     * 查询页面组件数据
     */
    getList() {
      DataFormApi.selectWidgetList(this.pageId).then(resp => {
        this.widgetViewList.push(...resp.data);
        console.log("=============>", this.widgetViewList);
      })
    },
  }

}
</script>

<style lang="less" scoped>
.workbench {
  transform: scale(1);
  transform-origin: top center;
  overflow-x: hidden;
}

.widget-item {
  padding: 0;
  margin: 0;
  position: absolute;
}
</style>
